import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as AuthFormActions from 'rebook/apps/users/actions/AuthFormActions';
import Form, { FormControl, FormRow, FormExtra } from 'rebook/apps/base/components/form/Form';
import Button from 'rebook/apps/base/components/Button';
import FormTextInput from 'rebook/apps/base/components/form/FormTextInput';
import { ABOUT_MYBOOK_ITEMS } from 'rebook/mybook/App/Footer/constants';
import AuthFormSocialAuth from 'rebook/mybook/App/AuthForm/AuthFormSocialAuth';


class AuthRegistrationForm extends React.Component {
  onBeforeSubmit() {
    if (this.props.type === 'registration' && this.props.GALabel) {
      ga('send', 'event', 'Registration', 'PushButton', this.props.GALabel);
    }
  }

  onSuccess() {
    if (this.props.type === 'registration' && this.props.GALabel) {
      ga('send', 'event', 'Registration', 'Registration', this.props.GALabel);
      yaMetrikaReachGoal('Registration');
    }
    if (this.props.onSuccess) {
      this.props.onSuccess();
    }
  }

  render() {
    const {
      onInit, onChange, onSubmit, onError, submitButtonText, AuthFormActions,
      form, isInProgress, errorList, handleChangeFormType, displaySocialAuth,
    } = this.props;
    return (
      <div className="jest-registration-form">
        <Form
          action="/api/registration/"
          method="post"
          onBeforeSubmit={this.onBeforeSubmit.bind(this)}
          onSubmit={onSubmit}
          onSuccess={this.onSuccess.bind(this)}
          onError={onError}>
          <FormRow extraClassName="jest-registration-email">
            <FormTextInput
              name="email"
              isDisabled={isInProgress}
              isRequired
              isRequiredError="Введите почту"
              onInit={onInit}
              onChange={onChange}
              errorList={errorList.email}
              value={form.email && form.email.value}
              label="Ваша электронная почта" />
          </FormRow>
          <FormRow extraClassName="jest-registration-password">
            <FormTextInput
              name="password"
              type="password"
              isDisabled={isInProgress}
              isRequired
              isRequiredError="Введите пароль"
              onInit={onInit}
              onChange={onChange}
              errorList={errorList.password}
              label="Придумайте пароль, пожалуйста" />
          </FormRow>
          <FormExtra>Не менее 8 символов, цифры и буквы.</FormExtra>
          <FormControl >
            <Button isInProgress={isInProgress}
              handleClick={()=>{ga('send', 'event', 'Registration', 'PushButton', 'Main');}}>
              {submitButtonText}
            </Button>
          </FormControl>
        </Form>
        {displaySocialAuth && (
          <FormExtra>
            <AuthFormSocialAuth />
          </FormExtra>
        )}
        <FormExtra>
          <Button
            extraClassName="jest-login-button"
            theme="secondary"
            size="small"
            handleClick={() => {
              ga('send', 'event', 'Login', 'CallForLogin');
              handleChangeFormType();
            }}>
            Войти
          </Button>
        </FormExtra>
        <FormExtra>
          Регистрируясь, вы принимаете
          <Link
            className="link"
            to={ABOUT_MYBOOK_ITEMS[2].url}
            onClick={() => AuthFormActions.hideForm()}> публичную оферту
          </Link> и
          <Link
            className="link"
            to={ABOUT_MYBOOK_ITEMS[1].url}
            onClick={() => AuthFormActions.hideForm()}> условия использования
          </Link> MyBook
        </FormExtra>
      </div>
    );
  }
};

AuthRegistrationForm.propTypes = {
  submitButtonText: PropTypes.string,
};

AuthRegistrationForm.defaultProps = {
  submitButtonText: 'Зарегистрироваться',
};

function mapDispatchToProps(dispatch) {
  return {
    AuthFormActions: bindActionCreators(AuthFormActions, dispatch),
  };
}
export default connect(null, mapDispatchToProps)(AuthRegistrationForm);
